import * as React from "react";
import { INTERNAL_DATA_LAKE_ID } from "data-lake/preview/storage-types/internal/Constants";
import PreviewLakeLogsButton from "./PreviewLakeLogsButton";
const PreviewInternalLakeLogsButton = ({ bsStyle, bsSize, target, children, streamId, onClick }) => /* @__PURE__ */ React.createElement(
  PreviewLakeLogsButton,
  {
    urlParams: `streams=${streamId}`,
    bsStyle,
    bsSize,
    target,
    dataLakeId: INTERNAL_DATA_LAKE_ID,
    onClick
  },
  children
);
export default PreviewInternalLakeLogsButton;
